import { useAppSelector } from "store/hooks";
import { getKey } from "app/shared/utils/EncryptionUtility";
import { getProcessedStoreInformation } from "store/slices/orderSliceUtil";
import { EntitiesEntity } from "app/features/Location/types/YextLocationResponseType";

export default function useIsTStore(): boolean {
    const hasToastRestaurantId = useAppSelector(
        (state) => Boolean(
            state.stores.selectedStore?.c_toastRestaurantId
            || state.stores.tRestaurantId,
        ),
    );
    if (hasToastRestaurantId) {
        return true;
    }
    const selectedStore = getKey('selectedStore') || null;
    if (!selectedStore) {
        return false;
    }
    const sessionStoreEntity = selectedStore
        ? JSON.parse(selectedStore) as EntitiesEntity
        : null;
    const defaultStoreInformation = getProcessedStoreInformation(sessionStoreEntity);
    return !!defaultStoreInformation.storeId;
}
